import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { useParams } from 'react-router-dom'
import { GroupNavi, HeaderNavi } from '../../components/navigation'
import Loading from '../../components/common/Loading'
import QrTagEventRecorder from '../../components/qr_tags/QrTagEventRecorder'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { getTeamGroups } from '../../modules/Team'
import { selectLoadingState } from '../../store'
import { toId } from '../../utils/commonUtils'
import './QrTagEventRecorder.css'

type Params = {
  group_id: string
}

const QrTagEventRecorderPage = () => {
  const { group_id: groupIdParam } = useParams<Params>()
  const dispatch = useAppDispatch()
  const loading = useAppSelector(selectLoadingState)
  const team = useAppSelector((state) => state.team)
  const [successMessage, setSuccessMessage] = useState<string | null>(null)

  useEffect(() => {
    if (!team.groups) {
      dispatch(getTeamGroups(false))
    }
  }, [dispatch, team.groups])

  const currentGroup = useMemo(() => {
    if (!groupIdParam) return null
    const targetId = toId<GroupId>(groupIdParam)
    return team.groups?.find((group) => toId(group.id) === targetId) ?? null
  }, [groupIdParam, team.groups])

  const handleEventCreated = useCallback(async () => {
    setSuccessMessage('イベントを記録しました。')
  }, [])

  return (
    <div className="content" data-testid="qr-tag-event-page">
      <HeaderNavi />
      <Loading show={loading} />
      <GroupNavi>
        <div className="qr-tag-event-page">
          <div className="qr-tag-event-page__header">
            <h2>QRタグイベント記録</h2>
            {currentGroup && (
              <p className="qr-tag-event-page__subtitle">
                {currentGroup.name}
                {' '}
                用のイベントを記録します。
              </p>
            )}
          </div>
          {successMessage && (
            <div className="qr-tag-event-page__flash">
              <span>{successMessage}</span>
              <button
                type="button"
                className="btn btn-link"
                onClick={() => setSuccessMessage(null)}
              >
                閉じる
              </button>
            </div>
          )}
          {!currentGroup && (
            <div className="qr-tag-event-page__empty">
              指定されたグループが見つかりません。
            </div>
          )}
          {currentGroup && (
            <QrTagEventRecorder
              group={currentGroup}
              onEventCreated={handleEventCreated}
            />
          )}
        </div>
      </GroupNavi>
    </div>
  )
}

export default QrTagEventRecorderPage
